import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services';

export const loginGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const session = await authService.getSession();
  if (session) {
    // If user is authenticated, redirect to home and block access to login
    router.navigate(['/']);
    return false;
  }
  // If not authenticated, allow access to login
  return true;
};
